// Опції для масового оновлення (мають співпадати з UPDATE_COMMANDS на бекенді)
export const UPDATE_STATUS_OPTIONS = [
  { value: "Оновити ВСЕ", label: "Оновити ВСЕ" },
  { value: "Ігнорувати", label: "Ігнорувати" },
  { value: "Оновити НАЯВНІСТЬ", label: "Оновити НАЯВНІСТЬ" },
];
